import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { onUnexpectedError } from '../../../../base/common/errors.js';
import { ViewPart } from '../../view/viewPart.js';
import { Position } from '../../../common/core/position.js';

var invalidFunc = function invalidFunc() {
  throw new Error("Invalid change accessor");
};

export var ViewZones = /*#__PURE__*/function (_ViewPart) {
  _inherits(ViewZones, _ViewPart);

  var _super = _createSuper(ViewZones);

  function ViewZones(context) {
    var _this;

    _classCallCheck(this, ViewZones);

    _this = _super.call(this, context);
    var options = _this._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this._lineHeight = options.get(51
    /* lineHeight */
    );
    _this._contentWidth = layoutInfo.contentWidth;
    _this._contentLeft = layoutInfo.contentLeft;
    _this.domNode = createFastDomNode(document.createElement('div'));

    _this.domNode.setClassName('view-zones');

    _this.domNode.setPosition('absolute');

    _this.domNode.setAttribute('role', 'presentation');

    _this.domNode.setAttribute('aria-hidden', 'true');

    _this.marginDomNode = createFastDomNode(document.createElement('div'));

    _this.marginDomNode.setClassName('margin-view-zones');

    _this.marginDomNode.setPosition('absolute');

    _this.marginDomNode.setAttribute('role', 'presentation');

    _this.marginDomNode.setAttribute('aria-hidden', 'true');

    _this._zones = {};
    return _this;
  }

  _createClass(ViewZones, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ViewZones.prototype), "dispose", this).call(this);

      this._zones = {};
    } // ---- begin view event handlers

  }, {
    key: "_recomputeWhitespacesProps",
    value: function _recomputeWhitespacesProps() {
      var _this2 = this;

      var whitespaces = this._context.viewLayout.getWhitespaces();

      var oldWhitespaces = new Map();

      var _iterator = _createForOfIteratorHelper(whitespaces),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var whitespace = _step.value;
          oldWhitespaces.set(whitespace.id, whitespace);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var hadAChange = false;

      this._context.model.changeWhitespace(function (whitespaceAccessor) {
        var keys = Object.keys(_this2._zones);

        for (var i = 0, len = keys.length; i < len; i++) {
          var id = keys[i];
          var zone = _this2._zones[id];

          var props = _this2._computeWhitespaceProps(zone.delegate);

          var oldWhitespace = oldWhitespaces.get(id);

          if (oldWhitespace && (oldWhitespace.afterLineNumber !== props.afterViewLineNumber || oldWhitespace.height !== props.heightInPx)) {
            whitespaceAccessor.changeOneWhitespace(id, props.afterViewLineNumber, props.heightInPx);

            _this2._safeCallOnComputedHeight(zone.delegate, props.heightInPx);

            hadAChange = true;
          }
        }
      });

      return hadAChange;
    }
  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._lineHeight = options.get(51
      /* lineHeight */
      );
      this._contentWidth = layoutInfo.contentWidth;
      this._contentLeft = layoutInfo.contentLeft;

      if (e.hasChanged(51
      /* lineHeight */
      )) {
        this._recomputeWhitespacesProps();
      }

      return true;
    }
  }, {
    key: "onLineMappingChanged",
    value: function onLineMappingChanged(e) {
      return this._recomputeWhitespacesProps();
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return e.scrollTopChanged || e.scrollWidthChanged;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    } // ---- end view event handlers

  }, {
    key: "_getZoneOrdinal",
    value: function _getZoneOrdinal(zone) {
      if (typeof zone.afterColumn !== 'undefined') {
        return zone.afterColumn;
      }

      return 10000;
    }
  }, {
    key: "_computeWhitespaceProps",
    value: function _computeWhitespaceProps(zone) {
      if (zone.afterLineNumber === 0) {
        return {
          afterViewLineNumber: 0,
          heightInPx: this._heightInPixels(zone),
          minWidthInPx: this._minWidthInPixels(zone)
        };
      }

      var zoneAfterModelPosition;

      if (typeof zone.afterColumn !== 'undefined') {
        zoneAfterModelPosition = this._context.model.validateModelPosition({
          lineNumber: zone.afterLineNumber,
          column: zone.afterColumn
        });
      } else {
        var validAfterLineNumber = this._context.model.validateModelPosition({
          lineNumber: zone.afterLineNumber,
          column: 1
        }).lineNumber;

        zoneAfterModelPosition = new Position(validAfterLineNumber, this._context.model.getModelLineMaxColumn(validAfterLineNumber));
      }

      var zoneBeforeModelPosition;

      if (zoneAfterModelPosition.column === this._context.model.getModelLineMaxColumn(zoneAfterModelPosition.lineNumber)) {
        zoneBeforeModelPosition = this._context.model.validateModelPosition({
          lineNumber: zoneAfterModelPosition.lineNumber + 1,
          column: 1
        });
      } else {
        zoneBeforeModelPosition = this._context.model.validateModelPosition({
          lineNumber: zoneAfterModelPosition.lineNumber,
          column: zoneAfterModelPosition.column + 1
        });
      }

      var viewPosition = this._context.model.coordinatesConverter.convertModelPositionToViewPosition(zoneAfterModelPosition);

      var isVisible = this._context.model.coordinatesConverter.modelPositionIsVisible(zoneBeforeModelPosition);

      return {
        afterViewLineNumber: viewPosition.lineNumber,
        heightInPx: isVisible ? this._heightInPixels(zone) : 0,
        minWidthInPx: this._minWidthInPixels(zone)
      };
    }
  }, {
    key: "changeViewZones",
    value: function changeViewZones(callback) {
      var _this3 = this;

      var zonesHaveChanged = false;

      this._context.model.changeWhitespace(function (whitespaceAccessor) {
        var changeAccessor = {
          addZone: function addZone(zone) {
            zonesHaveChanged = true;
            return _this3._addZone(whitespaceAccessor, zone);
          },
          removeZone: function removeZone(id) {
            if (!id) {
              return;
            }

            zonesHaveChanged = _this3._removeZone(whitespaceAccessor, id) || zonesHaveChanged;
          },
          layoutZone: function layoutZone(id) {
            if (!id) {
              return;
            }

            zonesHaveChanged = _this3._layoutZone(whitespaceAccessor, id) || zonesHaveChanged;
          }
        };
        safeInvoke1Arg(callback, changeAccessor); // Invalidate changeAccessor

        changeAccessor.addZone = invalidFunc;
        changeAccessor.removeZone = invalidFunc;
        changeAccessor.layoutZone = invalidFunc;
      });

      return zonesHaveChanged;
    }
  }, {
    key: "_addZone",
    value: function _addZone(whitespaceAccessor, zone) {
      var props = this._computeWhitespaceProps(zone);

      var whitespaceId = whitespaceAccessor.insertWhitespace(props.afterViewLineNumber, this._getZoneOrdinal(zone), props.heightInPx, props.minWidthInPx);
      var myZone = {
        whitespaceId: whitespaceId,
        delegate: zone,
        isVisible: false,
        domNode: createFastDomNode(zone.domNode),
        marginDomNode: zone.marginDomNode ? createFastDomNode(zone.marginDomNode) : null
      };

      this._safeCallOnComputedHeight(myZone.delegate, props.heightInPx);

      myZone.domNode.setPosition('absolute');
      myZone.domNode.domNode.style.width = '100%';
      myZone.domNode.setDisplay('none');
      myZone.domNode.setAttribute('monaco-view-zone', myZone.whitespaceId);
      this.domNode.appendChild(myZone.domNode);

      if (myZone.marginDomNode) {
        myZone.marginDomNode.setPosition('absolute');
        myZone.marginDomNode.domNode.style.width = '100%';
        myZone.marginDomNode.setDisplay('none');
        myZone.marginDomNode.setAttribute('monaco-view-zone', myZone.whitespaceId);
        this.marginDomNode.appendChild(myZone.marginDomNode);
      }

      this._zones[myZone.whitespaceId] = myZone;
      this.setShouldRender();
      return myZone.whitespaceId;
    }
  }, {
    key: "_removeZone",
    value: function _removeZone(whitespaceAccessor, id) {
      if (this._zones.hasOwnProperty(id)) {
        var zone = this._zones[id];
        delete this._zones[id];
        whitespaceAccessor.removeWhitespace(zone.whitespaceId);
        zone.domNode.removeAttribute('monaco-visible-view-zone');
        zone.domNode.removeAttribute('monaco-view-zone');
        zone.domNode.domNode.parentNode.removeChild(zone.domNode.domNode);

        if (zone.marginDomNode) {
          zone.marginDomNode.removeAttribute('monaco-visible-view-zone');
          zone.marginDomNode.removeAttribute('monaco-view-zone');
          zone.marginDomNode.domNode.parentNode.removeChild(zone.marginDomNode.domNode);
        }

        this.setShouldRender();
        return true;
      }

      return false;
    }
  }, {
    key: "_layoutZone",
    value: function _layoutZone(whitespaceAccessor, id) {
      if (this._zones.hasOwnProperty(id)) {
        var zone = this._zones[id];

        var props = this._computeWhitespaceProps(zone.delegate); // const newOrdinal = this._getZoneOrdinal(zone.delegate);


        whitespaceAccessor.changeOneWhitespace(zone.whitespaceId, props.afterViewLineNumber, props.heightInPx); // TODO@Alex: change `newOrdinal` too

        this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);

        this.setShouldRender();
        return true;
      }

      return false;
    }
  }, {
    key: "shouldSuppressMouseDownOnViewZone",
    value: function shouldSuppressMouseDownOnViewZone(id) {
      if (this._zones.hasOwnProperty(id)) {
        var zone = this._zones[id];
        return Boolean(zone.delegate.suppressMouseDown);
      }

      return false;
    }
  }, {
    key: "_heightInPixels",
    value: function _heightInPixels(zone) {
      if (typeof zone.heightInPx === 'number') {
        return zone.heightInPx;
      }

      if (typeof zone.heightInLines === 'number') {
        return this._lineHeight * zone.heightInLines;
      }

      return this._lineHeight;
    }
  }, {
    key: "_minWidthInPixels",
    value: function _minWidthInPixels(zone) {
      if (typeof zone.minWidthInPx === 'number') {
        return zone.minWidthInPx;
      }

      return 0;
    }
  }, {
    key: "_safeCallOnComputedHeight",
    value: function _safeCallOnComputedHeight(zone, height) {
      if (typeof zone.onComputedHeight === 'function') {
        try {
          zone.onComputedHeight(height);
        } catch (e) {
          onUnexpectedError(e);
        }
      }
    }
  }, {
    key: "_safeCallOnDomNodeTop",
    value: function _safeCallOnDomNodeTop(zone, top) {
      if (typeof zone.onDomNodeTop === 'function') {
        try {
          zone.onDomNodeTop(top);
        } catch (e) {
          onUnexpectedError(e);
        }
      }
    }
  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {// Nothing to read
    }
  }, {
    key: "render",
    value: function render(ctx) {
      var visibleWhitespaces = ctx.viewportData.whitespaceViewportData;
      var visibleZones = {};
      var hasVisibleZone = false;

      for (var i = 0, len = visibleWhitespaces.length; i < len; i++) {
        visibleZones[visibleWhitespaces[i].id] = visibleWhitespaces[i];
        hasVisibleZone = true;
      }

      var keys = Object.keys(this._zones);

      for (var _i = 0, _len = keys.length; _i < _len; _i++) {
        var id = keys[_i];
        var zone = this._zones[id];
        var newTop = 0;
        var newHeight = 0;
        var newDisplay = 'none';

        if (visibleZones.hasOwnProperty(id)) {
          newTop = visibleZones[id].verticalOffset - ctx.bigNumbersDelta;
          newHeight = visibleZones[id].height;
          newDisplay = 'block'; // zone is visible

          if (!zone.isVisible) {
            zone.domNode.setAttribute('monaco-visible-view-zone', 'true');
            zone.isVisible = true;
          }

          this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(visibleZones[id].verticalOffset));
        } else {
          if (zone.isVisible) {
            zone.domNode.removeAttribute('monaco-visible-view-zone');
            zone.isVisible = false;
          }

          this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(-1000000));
        }

        zone.domNode.setTop(newTop);
        zone.domNode.setHeight(newHeight);
        zone.domNode.setDisplay(newDisplay);

        if (zone.marginDomNode) {
          zone.marginDomNode.setTop(newTop);
          zone.marginDomNode.setHeight(newHeight);
          zone.marginDomNode.setDisplay(newDisplay);
        }
      }

      if (hasVisibleZone) {
        this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
        this.marginDomNode.setWidth(this._contentLeft);
      }
    }
  }]);

  return ViewZones;
}(ViewPart);

function safeInvoke1Arg(func, arg1) {
  try {
    return func(arg1);
  } catch (e) {
    onUnexpectedError(e);
  }
}